export default __webpack_public_path__ + "static/media/pak-airforce.095726d4.png";